import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useProductForm } from '../../contexts/ProductFormContext';

/**
 * The dedicated "create product" page was removed in favour of the product
 * form modal. Existing /products/create links (sidebar, top bar, dashboard
 * quick actions) land here, which opens the create modal and drops the user on
 * the product list.
 */
export function ProductCreateRedirect() {
  const { storeId } = useParams<{ storeId: string }>();
  const navigate = useNavigate();
  const { openCreate } = useProductForm();

  useEffect(() => {
    openCreate();
    navigate(`/${storeId}/products`, { replace: true });
  }, [storeId, navigate, openCreate]);

  return null;
}
